import axios from 'axios';
import { ADMIN_TOKEN_KEY } from '../contexts/AdminAuthContext';

// Story 28 — a separate axios instance from api/axios.js's tenant apiClient: it must never
// pick up the tenant jwt_token, and the tenant client must never pick up this one.
const adminApiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
});

adminApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default adminApiClient;
